module.exports = {
  "wxc-minibar": {
    "width": 750,
    "height": 90,
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "backgroundColor": "#009ff0"
  },
  "left": {
    "width": 90
  },
  "middle-title": {
    "fontSize": 30,
    "color": "#ffffff",
    "height": 36,
    "lineHeight": 34
  },
  "right": {
    "width": 80
  },
  "left-button": {
    "width": 21,
    "height": 36,
    "marginLeft": 40
  },
  "right-button": {
    "width": 32,
    "height": 32,
    "marginRight": 16
  },
  "right-text": {
    "width": 80,
    "marginRight": 20,
    "fontSize": 28,
    "textAlign": "left",
    "color": "#ffffff"
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-02d2e2e0!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-minibar/index.vue
// module id = 94
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28